import {variableRegex} from '../../../common/card-assembler/resolvers'
import {validProfileVarName} from '../../../common/variable-engine'

// this is actually expected to be in the form type.name or type.subtype.name,
// but not sure if this can be locked down?
export type VariablePath = string

export const getDataLabel = (path: VariablePath) => {
  // Profile snapshot vars are in the form 'profile.foo'
  // paths aren't used fully yet so returning the whole 'path' is acceptable
  if (path.match(validProfileVarName)) return path
  const split = path.split('.')
  return split[split.length - 1]
}

export const displayedValue = (path: VariablePath) =>
  '<span class="variable" data-path="' +
  path +
  '" contenteditable="false">' +
  getDataLabel(path) +
  '</span>'

// convert the editor's output into raw text content
export const serialiseVariables = (text: string) =>
  text.replace(
    // contenteditable inserts &nbsp; for us before and after the span, which
    // we don't want, so we detect and replace with a plain space here
    /(&nbsp;)?<span [^>]*?data-path="([\w.]+)".*?>.*?<\/span>(&nbsp;)?/g,
    (_, spaceBefore: string, path: string, spaceAfter: string) => {
      return path === '__new'
        ? ''
        : `${spaceBefore ? ' ' : ''}%{${path}}${spaceAfter ? ' ' : ''}`
    }
  )

// convert raw text content into the format expected by the editor
// Note, the regexp used here should allow for both theme and card variables
export const deserialiseVariables = (text: string) =>
  text.replace(variableRegex, (_, path: VariablePath) => displayedValue(path))
